import BlockIcon from "../../../../assets/img/page/blockicon.svg";
import gearPageIcon from "../../../../assets/img/page/gear.svg";
import trashIcon from "../../../../assets/img/page/trash.svg";
const ProductBlocks = ({ val, editModal, onDelete, draggableIcon }) => {
    const getHeading = () => {
      switch (val.type) {
        case 'three_box':
          return 'Feature';
        case 'faq':
          return JSON.parse(val.meta)?.faq_heading || 'FAQ';
        case 'custom_code':
            return 'Custom Code';
        default:
          return JSON.parse(val.meta)?.title || 'Title';
      }
    };
  
    return (
      <div data-block={val.id} className='mt-20px product-block'>
        <div className="editor-linku" id="folder-card">
          <div className="d-flex align-items-center editor-link-first-half">
            {draggableIcon()}
            <img src={BlockIcon} className="me-3" alt="Block Icon" />
            <div className="d-flex align-items-start justify-content-center flex-column">
              <h5 className="editor-link-headings mb-0">{getHeading()}</h5>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-end editor-link-second-half">
            <div className="d-flex align-items-center">
              <button
                className="btn btn-sm link-action-button product-link-action-button ms-2"
                data-id={val.id}
                onClick={(e) => editModal(e, val)}
              >
                <img
                  src={gearPageIcon}
                  width="14px"
                  alt="Edit"
                  data-id={val.id}
                  onClick={(e) => editModal(e, val)}
                />
              </button>
              <button
                className="btn btn-sm link-action-button product-link-action-button ms-2"
                onClick={() => onDelete(val.id)}
              >
                <img src={trashIcon} width="14px" alt="Delete" />
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };
  

  export default ProductBlocks;